import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { MEDIA_URL, MEDIA_URL2 } from '../../axios';
import submenuarrow from '../../Assets/Home/submenuarrow.svg';
import SectorMenu from './SectorMenu';
import logo1 from '../../Assets/Home/logo1.png';
import admin from "../../../src/Pages/AdminPanel/AdminLogin";
import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";

const Navbar = () => {
  const hamicon = MEDIA_URL + 'menu.svg';
  const hamcloseicon = MEDIA_URL + 'menuclose.svg';
  const uparrow = MEDIA_URL2 + 'Sectormenu/uparrow.svg';
  const downarrow = MEDIA_URL2 + 'Sectormenu/downarrow.svg';
  const linkedinicon = MEDIA_URL + 'Footer/linkedin.svg';
  const instagramicon = MEDIA_URL + 'Footer/instagram.svg';

  const location = useLocation(); // Access the current path
  const isHomePage = location.pathname === '/'; // Check if the current route is the home page

  let timeoutId;
  const sidebarRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isSectorMenuVisible, setIsSectorMenuVisible] = useState(false);
  const [isWorkMenuVisible, setIsWorkMenuVisible] = useState(false);
  const [isWorkSubMenuOpen, setIsWorkSubMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  let workTimeoutId;

  const handleMouseEnter = () => {
    clearTimeout(timeoutId);
    setIsSectorMenuVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutId = setTimeout(() => {
      setIsSectorMenuVisible(false);
    }, 100);
  };

  const handleWorkMouseEnter = () => {
    clearTimeout(workTimeoutId);
    setIsWorkMenuVisible(true);
  };

  const handleWorkMouseLeave = () => {
    workTimeoutId = setTimeout(() => {
      setIsWorkMenuVisible(false);
    }, 100);
  };

  const handleScroll = () => {
    if (window.scrollY > 40) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
    setIsSectorMenuVisible(false);
    setIsWorkMenuVisible(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="">
      <div
        className={`z-20 h-24 fixed px-4 max-sm:py-1 w-full flex flex-col justify-center items-center gap-2 md:px-14 py-1 circularstd transition-all duration-300 ${
          isHomePage
            ? hasScrolled
              ? 'bg-[#213140]' 
              : 'bg-[#213140]/0' 
            : 'bg-[#213140]' 
        }`}
      >
        {/* Main Navbar */}
        <div className="max-sm:justify-between max-sm:items-center mx-auto flex justify-between w-full ">
          <div className="logo">
            <NavLink to="/">
              <img
                className="max-sm:h-11 h-20 cursor-pointer hover:shadow-none"
                src={logo1}
                alt="Saptagon Logo"
              />
            </NavLink>
          </div>
          <div className="max-[1250px]:hidden flex">
            <ul className="flex items-center gap-3 font-normal text-white  ">
              <li>
                <NavLink to="/About-us" className={({ isActive }) => `${isActive ? "active-link p-2 hover:text-[#8364c3]" : "p-2 hover:text-white"}`}>About Us</NavLink>
              </li>
              <li className="relative" onMouseEnter={handleWorkMouseEnter} onMouseLeave={handleWorkMouseLeave}>
                <NavLink to="/Projects" className="p-2 flex items-center hover:text-white gap-2">
                  Our Work {isWorkMenuVisible ? <img src={uparrow} alt="Our Work Menu" className='rotate-180 transition-all' /> : <img src={downarrow} alt="Our Work Menu" className='transition-all' />}
                </NavLink>
                <div className={`absolute left-0 top-full pt-3 w-48 transition-all duration-300 ${isWorkMenuVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
                  <div className="bg-white rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.2)] overflow-hidden">
                    <Link to="/Map" className="block px-5 py-3 text-[#213140] hover:bg-[#f2f0fa] hover:text-[#8364c3] text-sm font-medium">Map</Link>
                    <a href="/#our-services" className="block px-5 py-3 text-[#213140] hover:bg-[#f2f0fa] hover:text-[#8364c3] text-sm font-medium border-t border-stone-100">Services</a>
                    <Link to="/Projects" className="block px-5 py-3 text-[#213140] hover:bg-[#f2f0fa] hover:text-[#8364c3] text-sm font-medium border-t border-stone-100">Projects</Link>
                  </div>
                </div>
              </li>
              <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <NavLink to="#" className="p-2 flex items-center hover:text-white gap-2">Sectors {isSectorMenuVisible ? <img src={uparrow} alt="Sector Menu" className='rotate-180 transition-all' /> : <img src={downarrow} alt="Sector Menu" className='transition-all' />}</NavLink>
              </li>
              <li>
                <NavLink to="/Lab" className={({ isActive }) => `${isActive ? "active-link p-2 hover:text-[#8364c3]" : "p-2 hover:text-white"}`}>Lab & Machinery</NavLink>
              </li>
              <li>
                <NavLink to="/Certifications" className={({ isActive }) => `${isActive ? "active-link p-2 hover:text-[#8364c3]" : "p-2 hover:text-white"}`}>Certifications</NavLink>
              </li>
              <li>
                <NavLink to="/Career" className={({ isActive }) => `${isActive ? "active-link p-2 hover:text-[#8364c3] " : "p-2 hover:text-white"}`}>Career</NavLink>
              </li>
              <li className="pl-10">
                <NavLink to="/Contact-us">
                  <div className="transition-transform transition-colors duration-300 transform hover:scale-105 rounded-xl  px-6 py-2 text-white bg-gradient-to-r from-[#61acca] to-[#8364c3]  shadow-md hover:shadow-xl">
                    Contact Us
                  </div>
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Mobile Ham Menu */}
          <div className="1250px:hidden block">
            {/* Hamburger Icon */}
            <button className="bg-transparent text-none p-4 max-[1175px]:block hidden" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <img src={hamcloseicon} alt="Menu" className="w-8" /> : <img src={hamicon} alt="Menu" className="w-8" />}
            </button>

            {/* Menu Items */}
            <div
              ref={sidebarRef}
              className={
                isOpen
                  ? "overflow-y-auto shadow-[5px_10px_28px_0_rgba(0,0,0,0.15)] text-white rounded-tl-xl rounded-bl-xl fixed  z-50 h-auto top-20 right-0 flex flex-col justify-between w-[80%] bg-[#222222] shadow-md max-[1175px]:flex hidden transition-all ease-in-out duration-500"
                  : "shadow-[5px_20px_28px_0_rgba(0,0,0,0.15)] text-white fixed h-[calc(100%-5rem)] z-40 top-20 right-[-100%] flex flex-col justify-between w-[80%] bg-[#222222] shadow-md max-[1175px]:flex hidden transition-all ease-in-out duration-500"
              }
            >
              <div className='ham-links'>
                <NavLink to="/About-us" onClick={() => setIsOpen(false)} className="md:text-2xl md:py-6 md:px-10 rounded-tl-xl active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#13ADCD] hover:text-white">About Us</NavLink>
                <div>
                  <button onClick={() => setIsWorkSubMenuOpen(!isWorkSubMenuOpen)} className="w-full flex items-center justify-between text-left md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">
                    Our Work
                    {isWorkSubMenuOpen ? <img src={submenuarrow} alt="Our Work Menu" className='max-md:w-3 w-5 rotate-180 transition-all' /> : <img src={submenuarrow} alt="Our Work Menu" className='max-md:w-3 w-5 transition-all' />}
                  </button>
                  {isWorkSubMenuOpen && (
                    <div className='pl-4'>
                      <Link to="/Map" onClick={() => { setIsOpen(false); setIsWorkSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Map</Link>
                      <a href="/#our-services" onClick={() => { setIsOpen(false); setIsWorkSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Services</a>
                      <Link to="/Projects" onClick={() => { setIsOpen(false); setIsWorkSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Projects</Link>
                    </div>
                  )}
                </div>
                <div>
                  <button onClick={() => setIsSubMenuOpen(!isSubMenuOpen)} className="w-full flex items-center justify-between text-left md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">
                    Sector
                    {isSubMenuOpen ? <img src={submenuarrow} alt="Sector Menu" className='max-md:w-3 w-5 rotate-180 transition-all' /> : <img src={submenuarrow} alt="Sector Menu" className='max-md:w-3 w-5 transition-all' />}
                  </button>
                  {isSubMenuOpen && (
                    <div className='pl-4'>
                      <NavLink to="/Sectors/Roads-&-Bridges" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Roads & Bridges</NavLink>
                      <NavLink to="/Sectors/Tunnels" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Tunnels</NavLink>
                      <NavLink to="/Sectors/Urban-Infrastructure" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Urban Infrastructure</NavLink>
                      <NavLink to="/Sectors/Railway" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Railway</NavLink>
                      <NavLink to="/Sectors/Metro" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Metro</NavLink>
                      <NavLink to="/Sectors/Lab-and-Machinery" onClick={() => { setIsOpen(false); setIsSubMenuOpen(false); }} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block border-b-2 px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Lab & Machinery</NavLink>
                    </div>
                  )}
                </div>
                <NavLink to="/Lab" onClick={() => setIsOpen(false)} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Lab & Machinery</NavLink>
                <NavLink to="/Certifications" onClick={() => setIsOpen(false)} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Certifications</NavLink>
                <NavLink to="/Career" onClick={() => setIsOpen(false)} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Career</NavLink>
                <NavLink to="/Contact-us" onClick={() => setIsOpen(false)} className="md:text-2xl md:py-6 md:px-10 active:bg-[#4FBECD] block px-6 py-4 text-xl text-white hover:bg-[#4FBECD] hover:text-white">Contact</NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Sector Menu */}
        {isSectorMenuVisible && <SectorMenu isVisible={isSectorMenuVisible} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />}
      </div>
    </div>
  );
};

export default Navbar;